import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import tranEn from './lang_er.json';
import tranKo from './lang_ko.json';

const resources = {
  "en-US": { translation: tranEn },
  "ko-KR": { translation: tranKo },
}

const userLanguage = window.navigator.language;

i18n.use(initReactI18next).init({
  resources,
  lng: userLanguage || 'ko-KR',
  fallbackLng: {
    'en-US': ['en-US'],
    default: ['ko-KR']
  },
  debug: false,
  keySeparator: false,
  interpolation: {
    escapeValue: false
  }
})

export default i18n;